angular.module('rjmNg.directives').directive "bulkDimensionEditor", [
  "$url"
  ($url) ->
    restrict: "E"
    templateUrl: "directive.bulkDimensionEditor.html"
    controllerAs: 'view'
    scope:
      action: '<'
      tables: '<'
      columns: '<'
      metrics: '<'
      showDepResolver: '&'
      onUpdate: '&'
      onCancel: '&'
    bindToController: true
    controller: [
      "logger"
      "metricEnums"
      "Metrics"
      "Dimensions"
      "app"
      "notification"
      "errorConstants"
      "dependencyEnums"
      "$q"
      (
        logger,
        metricEnums,
        Metrics,
        Dimensions,
        app,
        notification,
        errorConstants,
        dependencyEnums,
        $q
      ) ->

        notificationTimeout = 15
        _taStates = 
            all: 'rj-icon rj-icon--check-square-o'
            some: 'rj-icon rj-icon--minus-square-o'
            none: 'rj-icon rj-icon--square-o'

        view = @
        view.actionResultSummary = ""
        view.buttonClass = "rj-button--confirm"
        view.dimensionEditorActions = metricEnums.DIMENSION_EDITOR_ACTIONS
        view.loading = false
        view.selectedSourceTable = null
        view.tableSearchTerm = ""

        _getMetricsToUpdate = () ->
          dimToAdd = _selectedDimensions()
          dimAddCount = 0
          metUpdateMap = _.chain(_selectedMetrics())
                              .map((met) -> 
                                tempMet = angular.copy(met)
                                tempMet.needsToAdd = false
                                _.each(dimToAdd, (dim) ->
                                  foundDim = _.find(tempMet.dimensions, (md) -> return md.column_id is dim.id)
                                  if(!foundDim)
                                    #not found so needs to add
                                    dimAddCount++
                                    tempMet.needsToAdd = true
                                    tempMet.dimensions.push({
                                      column_id: dim.id
                                      is_groupable: if dim.isGroupable then true else false
                                    })
                                  else if(foundDim.is_groupable isnt dim.isGroupable)
                                    dimAddCount++
                                    tempMet.needsToAdd = true
                                    foundDim.is_groupable = dim.isGroupable

                                )
                                tempMet)
                              .reduce((accu, val) -> 
                                if(val.needsToAdd)
                                  accu[val.id] = val.dimensions
                                accu
                              ,{})
                              .value()

          if(Object.keys(metUpdateMap).length > 0)
            _generateActionResultSummary(dimAddCount, Object.keys(metUpdateMap).length)
            _getAndUpdateMetricDims(metUpdateMap, false)
          else
            notification.success("Success",
                "We found no dimensions that need to be added",
                "metrics",
                null,
                3
              )
            view.onCancel()

        # Compiles a summary of all the dimensions that were added/removed if any to/from how many metrics
        _generateActionResultSummary = (totalDimensions, totalMetrics) ->
          actionOn = if view.action is view.dimensionEditorActions.ADD then "pushed to" else "removed from"
          actionUsage = if view.action is view.dimensionEditorActions.ADD then "were already using" else "were not using any of"

          view.actionResultSummary = "#{totalDimensions} dimension(s) #{actionOn} #{totalMetrics} metric(s)."
          if totalMetrics is 0 and view.action is view.dimensionEditorActions.ADD
            view.actionResultSummary = "#{view.actionResultSummary} Looks like the metrics #{actionUsage} those dimensions."

        _getAndUpdateMetricDims = (listOfUpdates, del) ->
          view.loading = true
          getMetricsList = _.map(listOfUpdates, (val, key) -> return Metrics.get(app.getClientId(), key))
          $q.all(getMetricsList).then((metricsToUpdate) ->
            updateMetricList = _.map(metricsToUpdate, (met) -> 
                                  tempMet = angular.copy(met)
                                  _resolveNullDimensions(tempMet, listOfUpdates[tempMet.id], del)
                                  return Metrics.update(app.getClientId(), tempMet.id, tempMet))
            $q.all(updateMetricList).then(_handleMetricUpdateSucess, _handleMetricUpdateFail)
          , _handleGetFail)

        _deleteDimensions = (selection) ->
          dimChangeCount = 0
          metChangeCount = 0
          metUpdates = {}
          metToUpdate = _.chain(selection)
                          .map((sel, key) -> 
                            sel.metId = key.split(':')[0]
                            sel.dimId = parseInt(key.split(':')[1], 10)
                            sel)
                          .filter((sel) -> return sel.selected)
                          .groupBy('metId')
                          .map((dimsToDelete, metId) ->
                            newMet = angular.copy(_.find(view.metrics, (metToFind) -> return metToFind.id is parseInt(metId, 10) ))
                            newMet.ogDims = newMet.dimensions
                            newMet.dimensions = _.reject(newMet.dimensions, (dim) -> return _.find(dimsToDelete, (d2d) -> return d2d.dimId is dim.column_id))
                            if(newMet.ogDims.length isnt newMet.dimensions.length)
                              metChangeCount++
                              dimChangeCount+= newMet.ogDims.length - newMet.dimensions.length
                              metUpdates[newMet.id] = newMet.dimensions
                            newMet
                          )
                          .value()
          _generateActionResultSummary(dimChangeCount, metChangeCount)
          _getAndUpdateMetricDims(metUpdates, true)

        _handleGetFail = (error) ->
          view.loading = false
          notification.error("Server Error",
            errorConstants.SERVER_ERROR_MESSAGE,
            "metrics",
            null,
            notificationTimeout
          )
          $q.reject()  # break out of promise chain to not call more success callbacks


        _handleMetricUpdateSucess = (metrics) ->
          view.loading = false
          view.onUpdate({metrics: metrics})
          notification.success("Success",
            view.actionResultSummary,
            "metrics",
            null,
            notificationTimeout
          )
          logger.log('Metrics Page Usage', 'Bulk Dimension Edit', 1, view.action.toLowerCase())
          view.onCancel()

        _handleMetricUpdateFail = (error) ->
          view.loading = false
          if error.status is 422
            failedMetricName = error.config?.data?.name
            notification.error("Server Error", "Metric '#{failedMetricName}' was not updated because it is invalid.
                                  Please review the operator and columns used to ensure that they are properly defined
                                  (e.g. for COUNT operations, please make sure the Primary Key is counted).", "metrics")
          else
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metrics",
              null,
              notificationTimeout
            )
          view.onCancel()
        
        _resolveNullDimensions = (metric, dims, del) ->
          tempMetDims = metric.dimensions.slice(0)
          if(!del)
            metsToAdd = []
            for dim in dims
              updatedDim = false
              for metDim, ix in tempMetDims
                if(metDim.column_id is dim.column_id)
                  metric.dimensions[ix] = dim
                  updatedDim = true

              if(!updatedDim)
                metsToAdd.push(dim)
            metric.dimensions = metric.dimensions.concat(metsToAdd)
          else
            for metDim, ix in tempMetDims
              foundDim = false
              for dim in dims
                if(metDim.column_id is dim.column_id)
                  foundDim = true
              if(!foundDim && metDim.column_id isnt null)
                metric.dimensions[ix].column_id = null
            metric.dimensions

        _removeDimensionPromises = () ->
          view.loading = true
          dimToRemove = _selectedDimensions()
          metricsToUpdate = _selectedMetrics()
          depResolver = {
            dependencyPromises: {}
            depResourceNames: {}
          }
          dimPromises = []
          for met in metricsToUpdate
            for dim in dimToRemove
              if(_.find(met.dimensions, (metDim) -> return dim.id is metDim.column_id))
                depResolver.dependencyPromises["#{met.id}:#{dim.id}"] = Dimensions.dependents(
                    clientId: app.getClientId()
                    metricId: met.id
                    columnId: dim.id
                  ).$promise
                depResolver.depResourceNames["#{met.id}:#{dim.id}"] =
                  name: "#{met.name}.#{dim.name}"

          if Object.keys(depResolver.depResourceNames).length > 0
            depResolver.depResourceType = dependencyEnums.RESOURCE_TYPES.DIMENSION
            depResolver.depConfirmMsg = "Delete dimension(s) and reports?"
            depResolver.confirmDelete = _deleteDimensions
            view.loading = false
            view.showDepResolver({dep: depResolver})
          else
            view.loading = false
            notification.success("Success",
              "We found no dimensions that need to be deleted",
              "metrics",
              null,
              3
            )
            view.onCancel()

        _selectedDimensions = () ->
          view.dimensionOptions.filter((dim) -> dim.isSelected)

        _selectedDimensionsChange = () ->
          if(_selectedDimensions().length > 0)
            if(_selectedDimensions().length is view.dimensionOptions.length)
              view.dimensionsAllSelected = _taStates.all
            else
              view.dimensionsAllSelected = _taStates.some
          else
            view.dimensionsAllSelected = _taStates.none
          _validateEdit()

        _selectedMetrics = () ->
          view.metricOptions.filter((met) -> met.isSelected)

        _selectedMetricsChange = () ->
          if(_selectedMetrics().length > 0)
            if(_selectedMetrics().length is view.metricOptions.length)
              view.metricsAllSelected = _taStates.all
            else
              view.metricsAllSelected = _taStates.some
          else
            view.metricsAllSelected = _taStates.none
          _validateEdit()

        _validateEdit = () ->
          if(_selectedMetrics().length > 0 and _selectedDimensions().length > 0)
            view.canSave = true
          else
            view.canSave = false

        view.confirmDimensionDeleteCallback = (selection) ->
          _deleteDimensions(selection)

        view.cancelModal = () ->
          view.onCancel()

        view.init = (table = null) ->
          view.actionResultSummary = ""
          view.canSave = false
          view.tableOptions = view.tables
          view.metricOptions = []
          view.dimensionOptions = []
          view.dimensionsAllSelected = _taStates.none
          view.metricsAllSelected = _taStates.none

          if view.action is view.dimensionEditorActions.ADD
            view.actionSuffix = "to"
            view.buttonClass= "rj-button--confirm"
          if view.action is view.dimensionEditorActions.REMOVE
            view.actionSuffix = "from"
            view.buttonClass= "rj-button--danger"

        view.selectDimension = () ->
          _selectedDimensionsChange()
          
        view.selectMetric = () ->
          _selectedMetricsChange()

        view.setSourceTable = (table) ->
          view.selectedSourceTable = table
          view.metricOptions = _.chain(view.metrics)
                                .filter((met) -> met.table_id is table.id)
                                .map((met) ->
                                        tempMet = angular.copy(met)
                                        tempMet.isSelected = false
                                        tempMet)
                                .value()
          view.dimensionOptions = table.columns.map((dim) -> 
                                                      tempDim = angular.copy(dim)
                                                      tempDim.isSelected = false
                                                      tempDim.isGroupable = Metrics.guessGroupable(dim)
                                                      tempDim)
          _validateEdit()

        view.submit = ->
          if view.action is view.dimensionEditorActions.ADD
            _getMetricsToUpdate()
          if view.action is view.dimensionEditorActions.REMOVE
            _removeDimensionPromises()

        view.toggleAllDimensions = () ->
          allDimensionsState = true
          if(view.dimensionsAllSelected is _taStates.all)
            allDimensionsState = false

          for dim in view.dimensionOptions
            dim.isSelected = allDimensionsState
          
          _selectedDimensionsChange() 
        
        view.toggleAllMetrics = () ->
          allMetricsState = true
          if(view.metricsAllSelected is _taStates.all)
            allMetricsState = false

          for met in view.metricOptions
            met.isSelected = allMetricsState
          
          _selectedMetricsChange() 

        view.$postLink = () ->
          view.init()

        return view
    ]
  ]
